<template>
  <div>
    <breadcrumbs :back="back" :home="(productReconciliation.bonded  ? 'In-bond' : 'Duty-paid') + ' reconciliation transactions'"/>
    <purtrak-table name="reconcileproducttransactions" objectType="reconcile transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   :nonPagedItems="productReconciliation.transactions" listEndPoint="" fields=""
                   height="calc(100vh - 152px)"
                   @dblclick="product => viewTransaction(product)"
                   title="Product Reconciliation"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[$formatDateTime(productReconciliation.date),sites.length>1?productReconciliation.site.name:null]}">
      <template v-slot:filter>
        <div class="text-caption mr-1">{{productReconciliation.date | formatDateTime}}</div>
        <div v-if="sites.length > 1" class="text-caption mr-1">{{productReconciliation.site.name}}</div>
      </template>

      <template v-slot:item.bottles="{value,printing}">
        <template v-if="printing">{{value | number(0)}}</template>
        <span :class="{'red--text':value<0}">{{value | number(0)}}</span>
      </template>
      <template v-slot:item.cases="{value,printing}">
        <template v-if="printing">{{value | number(1)}}</template>
        <span :class="{'red--text':value<0}">{{value | number(1)}}</span>
      </template>
      <template v-slot:item.value="{value,printing}">
        <template v-if="printing">{{value | currency}}</template>
        <span :class="{'red--text':value<0}">{{value | currency}}</span>
      </template>
      <template v-slot:item.lot="{item,printing}">
        <template v-if="printing">{{item.lot}}</template>
        <v-hover v-else v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:[...back,{text:(productReconciliation.bonded  ? 'In-bond' : 'Duty-paid')+' reconciliation transactions',to:{name:'InventoryProductsReconcileTransactions',params:{id}}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:0}})"
             :class="{'text-decoration-underline':hover}">{{item.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="viewTransaction(item)"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item v-if="lotTracking"
                        :to="{name:'ReportsView',params:{back:[...back,{text:(productReconciliation.bonded  ? 'In-bond' : 'Duty-paid')+' reconciliation transactions',to:{name:'InventoryProductsReconcileTransactions',params:{id}}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:0}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="transaction=item;showDelete=true"><v-list-item-title>Delete transaction</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this transaction" @delete="performDeleteTransaction"/>
  </div>
</template>

<script>

export default {
  name: 'InventoryProductsReconcileTransactions',
  props: {
    id: {type:String, required:true}
  },
  data() {
    return {
      productReconciliation: {transactions:[],site:{}},
      transaction: null,
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true},
                       { value: 'description', visible:true},
                       { value: 'lot', visible:true},
                       { value: 'bottles', visible:true},
                       { value: 'cases', visible:false},
                       { value: 'value', visible:false}],
      headers: [{ text: 'PRODUCT', value: 'name', width:'30%',sortable:false},
                { text: 'ACTIVITY', value: 'description', width:'30%',sortable:false},
                { text: 'LOT', value: 'lot', width:'10%',sortable:true, omit:() => !this.lotTracking},
                { text: 'BOTTLES', value: 'bottles', width:'15%',sortable:true,align:'right'},
                { text: 'CASES', value: 'cases', width:'15%',sortable:true,align:'right'},
                { text: 'VALUE', value: 'value', width:'15%',sortable:true,align:'right',  omit:() => !this.values}]
    }
  },
  computed: {
    back() {
      return [{text:'Products',to:{name:'InventoryProducts'}},{text:'Product reconciliations',to:{name:'InventoryProductsReconcile'}}];
    },
    company() {
      return this.$store.getters.company;
    },
    sites() {
      return this.$store.getters.sites(true, this.productReconciliation.bonded ? {B262:true} : undefined);
    },
    values() {
      return this.company.permissions.includes('values');
    },
    readOnly() {
      return !this.company.permissions.includes('inventory.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    lotTracking() {
      return this.company.settings.lotTrackingForProducts && (this.productReconciliation.bonded || this.company.settings.lotTrackingForDutyPaid);
    }
  },
  async mounted() {
    this.loading = true;
    const results = await this.$apiCall(`query InventoryProductsReconcileTransactions($id:ID!) {
                                              productReconciliation(id:$id) {
                                                bonded,date,site{name}
                                                transactions {
                                                  id,type,name,description,bottles,cases,value,lot
                                                }
                                              }
                                            }`,
                                        {id:this.id});
    if (!results.error)
      this.productReconciliation = results.data.productReconciliation;
    this.loading = false;
  },
  methods: {
    viewTransaction(transaction) {
      this.$router.push({name:transaction.type==='ProductTransactionReduceInventory'?'InventoryProductsReduceInventory':'InventoryProductsAdjustInventory',params:{transactionId:transaction.id}});
    },
    async performDeleteTransaction() {
      this.loading = true;
      const results = await this.$apiCall(`mutation InventoryProductsReconcileTransactions($id: ID!) {
                                            objectDelete(id:$id)
                                          }`,
                                          {id:this.transaction.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table?.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted ${this.transaction.description} transaction`});
      }
    }
  }
}
</script>